export default __webpack_public_path__ + "static/media/linkedin_black_logo_icon_147114.9a1a7f81.png";